// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import {DataConfig} from "../app/core/config";
export const environment = {
    production: false
};
export const statFilterSet = {
    overview: ["distance", "bus", "alerts"],
    routes: ["bus", "alerts"],
    vehicles: ["distance", "totalTime", "alerts"]
};
export const Urls = {
    // use production url on staging as well
    // base_url: 'http://production.zophop2013.appspot.com/dashboard/',
    base_url: 'https://production.zophop.com/dashboard/enterprise/',
     //todo uncomment when need to use production url
    meta_call: 'https://gps.chalo.com/api/',
    // meta_call: 'http://staging.gps.chalo.com/api/',
    // scheduler_url: 'http://development.zophop.com:8080/scheduler_v4/v4/',
    scheduler_url: 'https://production.zophop.com/scheduler_v4/v4/',
    gps_base_url: 'https://analytics.gps.chalo.com/api/',
    live_base_url:'https://production.zophop.com/vasudha/',
    geo_query_url:'https://geoquery.zophop.com/'
};
// export const firebaseConfig = {
//     apiKey: 'AIzaSyAAS2tewbmsCJslVkn59r4jzqf3KlsiDiw',
//     authDomain: DataConfig.authDomain,
//     databaseURL: DataConfig.firebase_url,
//     storageBucket: 'dummy-d0e71.appspot.com'
// };
export const AgencyCenters = {
    NMMT: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 19.073421198240204,
        lng: 73.0104353399734
    },
    TMT: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 19.204864194890593,
        lng: 72.97766553402386
    },
    VVMT: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 19.376828420098942,
        lng: 72.82641858003049
    },
    BEST: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 19.014176160383684,
        lng: 72.85238199376849
    },
    KDMT: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 19.14567509338864,
        lng: 73.04091931899657
    },
    NMPL: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 21.140814737080277,
        lng: 79.08028897054557
    },
    AICTSL: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 22.717525488801915,
        lng: 75.85618128631336
    },
    CTU: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 30.715234135784726,
        lng: 76.74480659398967
    },
    BCLL: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 23.2599,
        lng: 77.4126
    },
    DTC: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 28.7041,
        lng: 77.1025
    },
    BMTC: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 12.9716,
        lng: 77.5946
    },
    'C-TYPE': {
        src: './../../../assets/chalo_logo_white.png',
        lat: 22.7196,
        lng: 75.8577
    },
    KMRL: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 9.9312,
        lng: 76.2673
    },
    JCTSL: {
        src: './../../../assets/chalo_logo_white.png',
        lat: 23.1815,
        lng: 79.9864
    },
    'IIM-INDORE': {
        src: './../../../assets/chalo_logo_white.png',
        lat: 22.682874,
        lng: 75.857348
    },
    brand: {
        src: './../../../assets/chalo_logo_white.png',
    }
};


export const cityCenter = {
    src: './../../../assets/chalo_logo_white.png',
    lat: 0,
    long: 0
};

